// ============================================
// ConverseTech Frontend - Session History Item
// ============================================

import { Link } from 'react-router-dom';
import { MessageCircle, Code, Users, Trophy } from 'lucide-react';
import type { SessionSummary, TrainingMode } from '@conversetech/shared';
import { TRAINING_MODE_LABELS } from '@conversetech/shared';

interface SessionHistoryItemProps {
  session: SessionSummary;
}

const MODE_ICONS: Record<TrainingMode, React.ElementType> = {
  conversation: MessageCircle,
  technical_explanation: Code,
  mock_interview: Users,
  duolingo_test: Trophy,
};

export default function SessionHistoryItem({ session }: SessionHistoryItemProps) {
  const Icon = MODE_ICONS[session.mode];
  const formattedDate = new Date(session.started_at).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });

  return (
    <Link
      to={`/session/${session.id}`}
      data-testid="session-history-item"
      className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-50 transition-colors"
    >
      <div className="w-10 h-10 bg-primary-100 text-primary-600 rounded-lg flex items-center justify-center">
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div data-testid="session-mode" className="font-medium text-gray-900 truncate">
          {TRAINING_MODE_LABELS[session.mode]}
        </div>
        <div className="flex items-center gap-3 text-sm text-gray-500">
          <span data-testid="session-date">{formattedDate}</span>
          <span>{session.duration_minutes} min</span>
        </div>
      </div>
      <div className="text-right">
        <div data-testid="session-det-score" className="font-semibold text-gray-900">
          {session.estimated_det_score}
        </div>
        <div className="text-xs text-gray-500">DET</div>
      </div>
    </Link>
  );
}
